export const PREMIUM_UPGRADE_FORM_CMS_URL =
    'https://www.wix.com/enterprise/form-cms';

export const PREMIUM_UPGRADE_BASE_URL = 'https://wix.com/wix/api/premiumStart';
